import React, { useEffect } from 'react';
import { EUSLBListItem } from '../../../model/EUSLBListItem';
import {
    DetailsList,
    IconButton,
    IContextualMenuItem,
    IContextualMenuProps, IDropdownStyles,
    Selection,
    TooltipOverflowMode,
    SelectionMode,
} from '@fluentui/react';
import { IStackStyles, StackItem } from '@fluentui/react/lib/Stack';
import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import QuickSearch from '../QuickSearch/QuickSearch';
import { fetchEUSLB } from "../../../services/AdminServices/EUSLBService";
import Pagination from "../../Pagination/Pagination";
import { useBoolean } from "@fluentui/react-hooks";
import { useAuth } from "react-oidc-context";
import styles from './EUSLB.module.css';
import EUSLBModal from '../EUSLB/EUSLBModal';
import EUSLBDeleteModal from '../EUSLB/EUSLBDeleteModal';
import { IColumn, MessageBarType } from "@fluentui/react";
import { Checkmark20Filled, Prohibited20Filled } from '@fluentui/react-icons';
import EiopaFnPIcons from "../../EiopaFnPIcons/EiopaFnPIcons";
import { displayMessageBar } from '../../LayoutWithAuth/LayoutWithAuth';
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import { Delete20Filled, FluentIconsProps } from "@fluentui/react-icons";
import strings from "../../../loc/strings.ts";

initializeIcons();

const options: IDropdownOption[] = [
    { key: 'id', text: 'ID' },
    { key: 'name', text: 'EU sectoral legislative basis' },
    { key: 'active', text: 'Active' },
];

const stackStyles: Partial<IStackStyles> = {
    root: {
        margin: "10px auto",
    },
};
interface IPagination {
    columnsState: IColumn[];
    currentPage: number;
    itemsPerPage: number;
    totalItems: number;
}

const customDropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 400 }

};

const customTextFieldStyles = {
    fieldGroup: {
        width: 400
    },
};

function EUSLB() {
    const auth = useAuth();
    const [deleteId, setDeleteId] = React.useState<number>(0);
    const [isSortedDescendings, { toggle: toggleIsSortedDescendings }] = useBoolean(true);

    // Static columns definition, will be replaced in the future with actual data from the API
    const EUSLBColumns: IColumn[] = [
        { key: 'column1', name: 'ID', fieldName: 'id', minWidth: 400, maxWidth: 400, isResizable: true },
        {
            key: 'column2', name: 'EU sectoral legislative basis', fieldName: 'name', minWidth: 450, maxWidth: 500, isResizable: true, isSorted: true,
            // sortBy: columns.filter(c => c.isSorted)[0].fieldName,
            // sortOrder: columns.filter(c => c.isSorted)[0].isSortedDescending ? 'asc' : 'desc'
            isSortedDescending: isSortedDescendings,
            sortAscendingAriaLabel: 'Sorted A to Z',
            sortDescendingAriaLabel: 'Sorted Z to A',
            onColumnClick: _onColumnClick,
            onRenderHeader: () => (
                <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={'EU sectoral legislative basis'}>{'EU sectoral legislative basis'}</TooltipHost>
            ),
        },
        {
            key: 'column3', name: 'Active', fieldName: 'active', minWidth: 400, maxWidth: 400, isResizable: true,

            onRender: (item: any) => {
                return item.active ? (
                    <Checkmark20Filled style={{ color: '#107C10' }} /> // icon for true
                ) : (
                    <Prohibited20Filled style={{ color: '#D83B01' }} /> // Icon for false
                );
            },
        },
        {
            key: 'actions',
            name: 'Actions',
            fieldName: 'actions',
            minWidth: 100,
            maxWidth: 100,
            onRender: (item: any) => {
                const menuProps: IContextualMenuProps = {
                    items: _EUSLBAction(item),
                    directionalHintFixed: false,
                    className: styles.actionsPanel
                };

                return (
                    <IconButton menuProps={menuProps}
                        onRenderIcon={_onRenderActionsIcon}
                        onRenderMenuIcon={_onRenderActionsMenuIcon}
                        title="Actions"
                        ariaLabel="Actions"
                    />
                );
            },
        },
    ];

    const iconStyleProps: FluentIconsProps = {
        primaryFill: "#0078D4",
        className: styles.filterIcon,
    };

    function onRenderPrefix() {
        return <Delete20Filled aria-label={"Filter"} {...iconStyleProps} />;
    }

    function _EUSLBAction(item: any): IContextualMenuItem[] {
        return [
            {
                key: 'edit',
                text: 'Edit',
                iconProps: { iconName: 'EditSolid12' },
                onClick: () => handleEditClick(item.id, item),
            },
            {
                key: 'delete',
                text: 'Delete',
                onRenderIcon: onRenderPrefix,
                onClick: () => handleDeleteClick(item.id, item),
            },
        ];
    }

    function _onRenderActionsIcon() {
        return <EiopaFnPIcons iconName={"actions"} iconColor={"#0078D4"} />;
    }

    function _onRenderActionsMenuIcon() {
        return <></>;
    }

    const [isEdit, setIsEdit] = React.useState<boolean>(false);
    const [deleteDialoghide, setDeleteDialoghide] = React.useState<boolean>(true);

    const resetIsEdit = (response: any) => {
        if (response === 'close') {
            setIsEdit(false);
        }
    }

    const resetDeleteDialoghide = (response: any) => {
        if (response === 'close') {
            setDeleteDialoghide(true);
            setDeleteId(0);
        }
    }

    const handleEditClick = (id: any, EUSLB: any) => {
        setIsEdit(true);
        seteditItemEUSLB(EUSLB);
    };

    const handleDeleteClick = (id: any, EUSLB: any) => {
        setDeleteDialoghide(false);
        setDeleteId(id);
        setDeleteItemEUSLB(EUSLB);
    };

    console.log('token', auth);
    // For later use in order to handle the state of the list
    const [items, setItems] = React.useState<EUSLBListItem[]>([]);
    // Needed for pagination
    const [itemsOrg, setItemsOrg] = React.useState<EUSLBListItem[]>([]);
    // const [selectedItems, setSelectedItems] = React.useState<Array<any>>([]);
    //selected item for pagination
    const [selectedItems, setSelectedItems] = React.useState<Object | undefined>(undefined)
    //totalitems for pagination
    const [totalItems, settotalItems] = React.useState<number>();
    // const [requestNo, setRequestNo] = useState<string | "">("");
    const [editItemEUSLB, seteditItemEUSLB] = React.useState<EUSLBListItem>({
        key: 0,
        id: 0,
        name: '',
        active: true,
    });
    const [deleteItemEUSLB, setDeleteItemEUSLB] = React.useState<EUSLBListItem>();

    // State hooks for pagination and column management
    const [state, setState] = React.useState<IPagination>({
        // selectedTab: Tab.Active,
        // isMetricsCalloutVisible: false,
        columnsState: EUSLBColumns,
        currentPage: 1,
        itemsPerPage: 50,
        totalItems: 0
    });

    function _onColumnClick(event: React.MouseEvent<HTMLElement>, column: IColumn) {
        toggleIsSortedDescendings();
        let isSortedDescending = column.isSortedDescending;

        if (column.isSorted) {
            isSortedDescending = !isSortedDescending;
        }

        let columns = state.columnsState.map(col => {
            col.isSorted = col.key === column.key;
            if (col.isSorted) {
                col.isSortedDescending = isSortedDescending;
            }
            return col;
        });

        const newItems = _copyAndSort(itemsOrg, column.fieldName!, isSortedDescendings);

        setItemsOrg(newItems);
        calculatePaginationItems(newItems);
    }

    function _copyAndSort<T>(items: T[], columnKey: string, isSortedDescending?: boolean): T[] {
        const key = columnKey as keyof T;
        return items.slice(0).sort((a: T, b: T) => {
            const aValue = String(a[key]);
            const bValue = String(b[key]);

            return isSortedDescending ? bValue.localeCompare(aValue) : aValue.localeCompare(bValue);
        });
    }

    function fetchAndCalculatePages() {
        // Fetch EUSLB data from the API
        (async function () {
            const result = await fetchEUSLB("1", auth.user?.id_token);
            setItems(result);
            setItemsOrg(result);
            const itemsLength = result.length;
            settotalItems(itemsLength);
        })();

        calculatePaginationItems(itemsOrg);


    }
    function calculatePaginationItems(items: EUSLBListItem[]) {

        // Calculate startIndex and endIndex for pagination
        const startIndex = (state.currentPage - 1) * state.itemsPerPage;
        const endIndex = Math.min(startIndex + state.itemsPerPage, items.length);
        const itemsOnCurrentPage = items.slice(startIndex, endIndex);
        setItems(itemsOnCurrentPage);


    }

    // Fetch EUSLB data from the API and update state
    useEffect(() => {
        fetchAndCalculatePages();

    }, []);

    //pagination
    const totalItemsToPass = totalItems !== undefined ? totalItems : 0;

    // Function to handle page change pagination
    function _onPageChange(selectedItem: number) {
        setState({
            ...state,
            currentPage: selectedItem
        });
    }

    // Effect to handle itemsPerPage change and update displayed items pagination
    useEffect(() => {
        calculatePaginationItems(itemsOrg);
    }, [state.currentPage, state.itemsPerPage, itemsOrg]);

    // Function to handle itemsPerPage change pagination
    function _onChangeItemsPerPage(event: React.FormEvent<HTMLDivElement>, item: IDropdownOption) {
        setState({
            ...state,
            itemsPerPage: item.key as number,
            currentPage: 1
        });
    }

    // Selection hook for DetailsList
    const selection = new Selection({
        onSelectionChanged: () => {
            // Update the selected items when the user changes the selection
            setSelectedItems(selection.getSelection());
        },
    });
    // Function to handle processed data from QuickSearch component
    const handleItemsProcessed = (processedData: any) => {
        settotalItems(processedData.length);

        // Update the items state with the processed data
        if (processedData.length > 0) {
            calculatePaginationItems(processedData);
            setState({
                ...state,
                currentPage: 1
            });
        } else {
            // If no processed data, revert to the original items
            setItems([]);
        }
    };

    const handleActionResponse = (response: string) => {
        fetchAndCalculatePages();

        const fallbackMessage = strings.euSLBUnexpectedError;

        const extractMessage = (res: any): string => {
            if (res === "uniquenameerror" || res?.message === "uniquenameerror") {
                return strings.euSLBNameExistsError;
            }

            if (typeof res === "string") {
                return res;
            }

            if (res?.message) {
                try {
                    const parsed = JSON.parse(res.message);
                    if (Array.isArray(parsed.errors)) {
                        return parsed.errors.join(", ");
                    }
                } catch {
                    return res.message;
                }
            }

            return fallbackMessage;
        };

        let message;
        let messageBarType;

        switch (response) {
            case "createtrue":
                message = "The EU sectoral Legislative basis is added successfully in the system.";
                messageBarType = MessageBarType.success;
                displayMessageBar(messageBarType, message, false);
                break;
            case "createfalse":
                message = "Error the Name already exists.";
                messageBarType = MessageBarType.error;
                displayMessageBar(messageBarType, message, false);
                break;
            case "edittrue":
                message = "The EU sectoral Legislative basis is updated successfully.";
                messageBarType = MessageBarType.success;
                displayMessageBar(messageBarType, message, false);
                break;
            case "editfalse":
                message = extractMessage(response);
                messageBarType = MessageBarType.error;
                displayMessageBar(messageBarType, message, false);
                break;
            case "deletetrue":
                message = "The EU sectoral Legislative basis is deleted successfully from the system.";
                messageBarType = MessageBarType.success;
                displayMessageBar(messageBarType, message, false);
                break;
            case "deletefalse":
                message = "The EU sectoral legislative basis cannot be deleted because it is being used in a Request for information.";
                messageBarType = MessageBarType.error;
                displayMessageBar(messageBarType, message, false);
                break;
            default:
                displayMessageBar(MessageBarType.error, extractMessage(response), false);
                break;
        }
    };

    function _renderItemColumn(item?: any, index?: number, column?: IColumn) {
        if (item && column) {
            const fieldContent = item[column.fieldName as keyof any] as string;
            return <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={fieldContent}>{fieldContent}</TooltipHost>
        }
    }

    const addTooltipToColumnHeader = (cols: IColumn[]) => {
        const a = cols.map((column) => ({
            ...column,
            onRenderHeader: () => (
                <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={column.name}>{column.name}</TooltipHost>
            ),
        }))
        return cols;
    }

    return (
        <>
            <StackItem styles={stackStyles}>
                <StackItem className={styles.EUSLBHeader}>
                    EU sectoral legislative basis
                </StackItem>
                {/* Quick search component */}
                <div className={styles.headerbar}>
                    <QuickSearch options={options} items={items} itemsOrg={itemsOrg} onItemsProcessed={handleItemsProcessed} columns={EUSLBColumns} selection={selectedItems} textFieldStyles={customTextFieldStyles} dropdownStyles={customDropdownStyles} />
                    <EUSLBDeleteModal resetDeleteDialoghide={resetDeleteDialoghide} deleteDialoghide={deleteDialoghide} deleteId={deleteId} deleteItem={deleteItemEUSLB} handleActionResponse={handleActionResponse} />
                    <EUSLBModal handleActionResponse={handleActionResponse} options={EUSLBColumns} isEdit={isEdit} resetIsEdit={resetIsEdit} editItem={editItemEUSLB} />
                </div>
                {/* DetailsList component */}
                <DetailsList
                    selection={selection}
                    selectionMode={SelectionMode.none}
                    selectionPreservedOnEmptyClick={true}
                    layoutMode={1}
                    columns={addTooltipToColumnHeader(EUSLBColumns)}
                    items={items}
                    onRenderItemColumn={_renderItemColumn}

                />
            </StackItem>
            <StackItem>
                <Pagination
                    currentPage={state.currentPage}
                    onPageChange={_onPageChange}
                    itemsPerPage={state.itemsPerPage}
                    onChangeItemsPerPage={_onChangeItemsPerPage}
                    totalItems={totalItemsToPass}
                />
            </StackItem>
        </>
    );
}

export default EUSLB;
